import WRAP from 'WRAP-JS';
import ContentsBase from './ContentsBase';

class SRTMElevation extends ContentsBase {
  constructor() {
    super('Elevation', 'ELEVATION', 'Elevation');
  }

  addObject() {
    return new Promise((resolve, reject) => {
      this.dataHandler = WRAP.DH.addObject(this.dataConfName);
      WRAP.DH.wait(this.dataHandler, function () {
        this.dataReference = this.dataHandler;
        resolve();
      }.bind(this));
    });
  }

  getOpt() {
    return {
      Elevation: this.isVisible()
    };
  }

  /**
   * 表示フラグを設定する.
   * @param {boolean} visible 表示フラグ
   */
  setVisible(visible) {
    this.visible = visible;
  }
}

export default SRTMElevation;